import { Search } from "lucide-react";

import { Input } from "../../ui/input";

type SpotlightSearchProps = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
};

export const SpotlightSearch = ({
  value = "",
  onChange,
  placeholder = "Type Case Number, Claim Reference Number or Examinee Name here..",
}: SpotlightSearchProps) => {
  return (
    <Input
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      rightIcon={<Search className="size-4 text-foreground-muted" />}
      className="bg-background-white py-2"
    />
  );
};
